import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import moment from 'moment';

import momentbusiness from 'moment-business-time'
import helpers from '../Function';
import { config } from '../Constants';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import { withRouter } from "react-router-dom";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import $ from "jquery"

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { ExcelRenderer } from 'react-excel-renderer';
import ReactExport from 'react-data-export';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const imgpath = `https://app.nvdsmarthome.com/`
const imgpath = `http://58.137.160.78:4000/`
moment.locale('en', {
    workinghours: {
        0: null,
        1: ['00:00:00', '23:59:59'],
        2: ['00:00:00', '23:59:59'],
        3: ['00:00:00', '23:59:59'],
        4: ['00:00:00', '23:59:59'],
        5: ['00:00:00', '23:59:59'],
        6: null
    }
});

const style = {
    border: {
        top: { style: "thin", color: { rgb: "000000" } }
        , left: { style: "thin", color: { rgb: "000000" } }
        , right: { style: "thin", color: { rgb: "000000" } }
        , bottom: { style: "thin", color: { rgb: "000000" } }
    }
    , font: { name: "Tahoma", sz: "10" }
    , fill: { patternType: "solid", fgColor: { rgb: "ffffff" } }
}

class Worksheet extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            pages: [],
            user_permission: user_permission,
            project_home: [],
            service_category: [],
            coordinate: [],
            service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }],
            userid: user_id,
            src_house_no: '',
            src_no: '',
            src_status: '',
            src_category: '',
            src_project: '',
            src_owner: '',
            src_phone: '',
            jwt: jwt,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            addIsOpen: false,
            srcIsOpen: false,
            doncaseIsOpen: false,
            modalIsOpen: false,
            SLAIsOpen: false,
            updateIsOpen: false,
            add_id: '',
            add_number: '',
            add_service_date: '',
            add_service_time: '',
            add_member_name: '',
            add_owner_name: '',
            add_phone_come: '',
            add_project_name: '',
            val_project_name: '',
            add_home_number: '',
            add_project_status: '',
            add_category: '',
            add_warranty_date: '',
            add_title: '',
            add_contact: '',
            add_service_status: '',
            add_detail: '',
            add_sla_val: '',
            val_service_status: '',
            old_service_status: '',
            val_category: '',
            val_project_status: '',
            createby_name: '',
            add_first_name: '',
            add_last_name: '',
            page: 0,
            rowsPerPage: 10,
            coor_detail: '',
            office_id: '5a627dab3fc2394c4f824e94',
            save_value: 'save',
            miss_suc: helpers.getUserType(user_type, "suc"),
            miss_su: helpers.getUserType(user_type, "su"),
            miss_acc: helpers.getUserType(user_type, "acc"),
            miss_cc: helpers.getUserType(user_type, "cc"),
            sla_start_date: '',
            sla_start_time: '',
            sla_end_date: '',
            sla_start_time: '',
            add_sla_val: 0,
            express: '',
            fromList: [],
            detail1: '',
            detail2: '',
            detail3: '',
            detail4: '',
            detail5: '',
            detail6: '',
            detail7: '',
            detail8: '',
            detail9: '',
            detail10: '',
            subscriber1: '',
            subscriber2: '',
            subscriber3: '',
            subscriber4: '',
            subscriber5: '',
            subscriber6: '',
            subscriber7: '',
            subscriber8: '',
            subscriber9: '',
            subscriber10: '',
            operator1: '',
            operator2: '',
            operator3: '',
            operator4: '',
            operator5: '',
            operator6: '',
            operator7: '',
            operator8: '',
            operator9: '',
            operator10: '',
            note1: '',
            note2: '',
            note3: '',
            note4: '',
            note5: '',
            note6: '',
            note7: '',
            note8: '',
            note9: '',
            note10: '',
            serviceStatus1: '',
            serviceStatus2: '',
            serviceStatus3: '',
            serviceStatus4: '',
            serviceStatus5: '',
            serviceStatus6: '',
            serviceStatus7: '',
            serviceStatus8: '',
            serviceStatus9: '',
            serviceStatus10: '',
            serviceDate1: '',
            serviceDate2: '',
            serviceDate3: '',
            serviceDate4: '',
            serviceDate5: '',
            serviceDate6: '',
            serviceDate7: '',
            serviceDate8: '',
            serviceDate9: '',
            serviceDate10: '',
            successDate1: '',
            successDate2: '',
            successDate3: '',
            successDate4: '',
            successDate5: '',
            successDate6: '',
            successDate7: '',
            successDate8: '',
            successDate9: '',
            successDate10: '',
            editDate1: '',
            editDate2: '',
            editDate3: '',
            editDate4: '',
            editDate5: '',
            editDate6: '',
            editDate7: '',
            editDate8: '',
            editDate9: '',
            editDate10: '',
            sendEmail: false,
            showDetail10: false,
            src_channel: "",
            value: "urgent",
            add_sla: 0,
            sla_detail_start_date: '',
            sla_detail_start_time: '',
            sla_detail_end_date: '',
            sla_detail_end_time: '',
            detail_id: '',
            multiDataSet: [],
            ImgIsOpen: false,
            img: '',
            imagephoto: [],
            src_name: '',
            Ismore: false
        };

        // for (var i = 1; i <= 10; i++) {
        //     this.state.fromList.push({
        //         row: i
        //         , col1: "detail" + i
        //         , col2: "subscriber" + i
        //         , col3: "operator" + i
        //         , col4: "serviceDate" + i
        //         , col5: "successDate" + i
        //         , col6: "editDate" + i
        //         , col7: "note" + i
        //         , col8: "serviceStatus" + i
        //         ,
        //     });
        // }

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.dataTable = this.dataTable.bind(this);

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.openView = this.openView.bind(this);
        this.openSLA = this.openSLA.bind(this)

        this.closeModal = this.closeModal.bind(this);
        this.closeDoneCase = this.closeDoneCase.bind(this);
        this.openDoneCase = this.openDoneCase.bind(this);
        this.submitDoneCase = this.submitDoneCase.bind(this);
        this.change = this.change.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.closeSrc = this.closeSrc.bind(this);

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.openModal = this.openModal.bind(this);

        this.cancelCoordinate = this.cancelCoordinate.bind(this);
        this.submitCoordinate = this.submitCoordinate.bind(this);
        this.clearListDetail = this.clearListDetail.bind(this);

        this.submitSLANormal = this.submitSLANormal.bind(this)

        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.openImg = this.openImg.bind(this);
        this.closeImg = this.closeImg.bind(this);
        this.project_home()
        this.dataTable();
    }

    openImg(e) {
        var imgs = JSON.parse(e.currentTarget.attributes["data-id"].value)

        var photo = imgs.map(datas => {
            return `${imgpath}${datas.img}`
        });

        this.setState({
            ImgIsOpen: true,
            imagephoto: photo
        });
    }

    closeImg() {
        this.setState({ ImgIsOpen: false });
    }

    project_home() {
        var body = ``
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.PROJECTID) {
            body = `?projecthomeid=${this.state.PROJECTID}`
            fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        } else {
            fetch(config.url.API_URL + '/project_homes/', requestOptions)
                .then(res => res.json())
                .then(data => {
                    var sortData = data.data.sort(function (a, b) {
                        return a.num - b.num;
                    });

                    var found = sortData.filter(function (item) { return item.active; });
                    var found2 = found.filter(function (item) { return !item.delete; });

                    var FromApi = found2.map(data => {
                        return { value: data.id, display: data.name_th }
                    });

                    this.setState({
                        project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                    });
                });
        }

    }

    clearListDetail() {
        for (var i = 1; i <= 10; i++) {
            this.setState({
                ["detail" + i]: '',
                ["subscriber" + i]: '',
                ["operator" + i]: '',
                ["serviceDate" + i]: '',
                ["successDate" + i]: '',
                ["editDate" + i]: '',
                ["note" + i]: '',
                ["serviceStatus" + i]: '',
                fromList: []
            })
        }
    }

    changeSLAStartDate = date => {
        this.setState({
            sla_start_date: date
        });
    }

    changeSLAEndDate = date => {
        this.setState({
            sla_end_date: date
        });
    }

    componentDidMount() {
        helpers.checklogin(this.state.jwt);

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.category) {

            fetch(config.url.API_URL + '/service_types/?categoryid=' + this.state.category + '&sortnameth=1', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    var FromApi = data.data.map(datas => {
                        return { value: datas.id, display: datas.name_th }
                    });
                    this.setState({
                        service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                    });
                }, function (error) {
                    console.log("==============error authen==================" + error);
                })
        }

        fetch(config.url.API_URL + '/service_categorys?type=hc', requestOptions)
            .then(res => res.json())
            .then(data => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //alert(data.status);
                var FromApi = data.data.map(datas => {
                    return { value: datas.id, display: datas.name_th }
                });
                console.log(FromApi)
                this.setState({
                    service_category: [{ value: '', display: 'เลือกหมวดเรื่อง' }].concat(FromApi)
                });
            });

    }

    showOption(option, val, display) {
        if (option == val) {
            return <option value={val} selected>{display}</option>
        } else {
            return <option value={val}>{display}</option>
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });

        if (e.target.name == "add_category") {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            fetch(config.url.API_URL + '/service_types/?categoryid=' + e.target.value + '&sortnameth=1', requestOptions)
                .then(res => res.json())
                .then(data => {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    //alert(data.status);
                    var FromApi = data.data.map(datas => {
                        return { value: datas._id, display: datas.name_th }
                    });
                    this.setState({
                        service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                    });
                });
        }

    }

    dataTable() {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        if (this.state.PROJECTID) {
            this.state.src_project = this.state.PROJECTID
        }

        //var permission_id = ""

        // if (this.state.miss_suc || this.state.miss_su || this.state.miss_acc) {
        //     permission_id = ""
        // } else {
        //     permission_id = "&permission_id=" + (this.state.create_by_id ? this.state.create_by_id : '')
        // }

        // var create_id = ""

        // if (this.state.miss_cc) {
        //     create_id = "&create_id=" + (this.state.userid ? this.state.userid : '');
        //     permission_id = "";
        // }

        fetch(config.url.API_URL + '/service_complaints/?phone=' + (this.state.src_phone ? this.state.src_phone : '')
            + '&projecthomeid=' + (this.state.src_project ? this.state.src_project : '')
            + '&houseno=' + (this.state.src_house_no ? this.state.src_house_no : '')
            + '&category=' + (this.state.src_category ? this.state.src_category : '')
            + "&owner=" + (this.state.src_owner ? this.state.src_owner : '')
            + "&name=" + (this.state.src_name ? this.state.src_name : '')
            + "&service_number=" + (this.state.src_no ? this.state.src_no : '')
            + "&servicestatus=" + (this.state.src_status ? this.state.src_status : '')
            + "&channel=" + (this.state.src_channel ? this.state.src_channel : '')
            // + permission_id
            // + create_id
            + "&contactchanel=cc"
            + "&bystatus=1"
            // + "&title=1"
            //+"&usertype="+(Array.isArray(this.state.usertype) && this.state.usertype.length? (this.state.usertype[0].user_type=='su' || this.state.usertype[0].user_type=='suc'?'':this.state.usertype[0].user_type):'')
            , requestOptions)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data.data) && data.data.length) {
                    var FromApi = data.data.map(datas => {
                        var btnupdate = (<div></div>)
                        var btndone = (<div></div>)
                        if (datas.service_status != 'close' && datas.service_status != 'cancel') {
                            btnupdate = (<button className="btn-action text-center" data-id={datas._id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" /> Update</button>)
                        }

                        if (datas.service_status != 'close' && datas.service_status != 'cancel') {
                            btndone = (<button className="btn-action text-center" data-id={datas._id} onClick={this.openDoneCase}>Done Case</button>)
                        }

                        return {
                            id: datas._id,
                            number: datas.service_number,
                            service_date: moment(datas.created).format('DD/MM/YYYY'),
                            service_time: moment(datas.created).format('H:mm'),
                            member_name: datas.member_first_name + ' ' + datas.member_last_name,
                            owner_name: datas.onwer_first_name + ' ' + datas.owner_last_name,
                            phone_come: datas.income_phone,
                            project_name: (Array.isArray(datas.project_homes) && datas.project_homes.length ?
                                datas.project_homes[0].name_th : ''),
                            home_number: datas.home_number,
                            project_status: helpers.getProjectStatus(datas.project_status),
                            category: (Array.isArray(datas.service_categorys) && datas.service_categorys.length ?
                                datas.service_categorys[0].name_th : ''),
                            warranty_date: moment(datas.delivery_date).format('DD/MM/YYYY') + ' - ' + moment(datas.expired_insurance).format('DD/MM/YYYY'),
                            title: (Array.isArray(datas.service_types) && datas.service_types.length ?
                                datas.service_types[0].name_th : ''),
                            contact: helpers.getContactChannel(datas.contact_chanel),
                            service_status: helpers.getServiceStatus(datas.service_status),
                            express: datas.express,
                            btnUpdate: btnupdate,
                            btnDoneCase: btndone,
                            updateby: datas.updateby == undefined ? datas.createby : datas.updateby,
                            updated: datas.updated != undefined ? `${moment(datas.updated).format("DD/MM/YYYY HH:mm น.")}` : `${moment(datas.created).format("DD/MM/YYYY HH:mm น.")}`,
                        }
                    });

                    this.setState({
                        pages: [].concat(FromApi)
                    });

                } else {
                    this.setState({
                        pages: []
                    });
                }

            });

    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add'
        });
    }

    openView(e) {
        this.clearListDetail();

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/service_complaints/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                var datas = data.data[0];
                if (datas.service_types[0].multi == 1) {
                    this.setState({
                        Ismore: true
                    });
                } else {
                    this.setState({
                        Ismore: false
                    });
                }
                for (var i = 1; i <= datas.detail_list.length; i++) {
                    this.state.fromList.push({
                        row: i
                        , col1: "detail" + i
                        , col2: "subscriber" + i
                        , col3: "operator" + i
                        , col4: "serviceDate" + i
                        , col5: "successDate" + i
                        , col6: "editDate" + i
                        , col7: "note" + i
                        , col8: "serviceStatus" + i
                        , images: "img" + i
                        , _id: "_id" + i
                        , service_type_id: "service_type_id" + i
                        , service_type_name: "service_type_name" + i
                        , service_type_id: "service_type_id" + i
                        , service_type_name: "service_type_name" + i
                    });
                }
                if (datas.detail_list != undefined) {
                    datas.detail_list.map((dt, i) => {
                        console.log(dt)

                        this.setState({
                            ['_id' + (i + 1)]: dt._id,
                            ['detail' + (i + 1)]: dt.detail,
                            ['subscriber' + (i + 1)]: dt.subscriber,
                            ['operator' + (i + 1)]: dt.operator,
                            ['serviceDate' + (i + 1)]: (dt.serviceDate != undefined ? new Date(dt.serviceDate) : ""),
                            ['successDate' + (i + 1)]: (dt.successDate != undefined ? new Date(dt.successDate) : ""),
                            ['editDate' + (i + 1)]: (dt.editDate != undefined ? new Date(dt.editDate) : ""),
                            ['note' + (i + 1)]: dt.note,
                            ['serviceStatus' + (i + 1)]: dt.serviceStatus,
                            //['img' + (i + 1)]: dt.img.length > 0 ? `${imgpath}${dt.img[0].img}` : "",
                            ['img' + (i + 1)]: dt.img.length > 0 ? JSON.stringify(dt.img) : "",
                            img: dt.img.length > 0 ? `${imgpath}${dt.img[0].img}` : "",
                            ['service_type_id' + (i + 1)]: dt.service_type_id,
                            ['service_type_name' + (i + 1)]: dt.service_type_name,
                        })
                    });
                }

                var detail = <div></div>;

                if (datas.detail) {
                    detail = datas.detail.split('\n').map((item, i) => {
                        return <div>{item}<br /></div>;
                    });
                }

                var create_type = ""
                if (Array.isArray(datas.user_create) && datas.user_create.length
                    && Array.isArray(datas.user_create[0].user_type) && datas.user_create[0].user_type.length) {
                    create_type = " (" + helpers.getPermission(datas.user_create[0].user_type[0].user_type) + ")";
                }

                var FromExcel = datas.detail_list.map((datas, i) => {
                    return [
                        { value: i + 1, style },
                        { value: datas.detail, style },
                        { value: (datas.serviceDate != undefined ? moment(datas.serviceDate).format('DD/MM/YYYY') : ""), style },
                        { value: '', style },
                    ]
                });

                this.setState({
                    add_id: datas._id,
                    add_number: datas.service_number,
                    add_service_date: moment(datas.created).format('DD/MM/YYYY'),
                    add_service_time: moment(datas.created).format('H:mm'),
                    add_member_name: datas.member_first_name + ' ' + datas.member_last_name,
                    add_owner_name: datas.owner_first_name + ' ' + datas.owner_last_name,
                    add_first_name: datas.member_first_name,
                    add_last_name: datas.member_last_name,
                    add_phone_come: datas.income_phone,
                    add_group: (Array.isArray(datas.service_groups) && datas.service_groups.length ?
                        datas.service_groups[0].name_th : ''),
                    add_project_name: (Array.isArray(datas.project_homes) && datas.project_homes.length ? datas.project_homes[0].name_th : ''),
                    add_home_number: datas.home_number,
                    add_project_status: helpers.getProjectStatus(datas.project_status),
                    add_category: (Array.isArray(datas.service_categorys) && datas.service_categorys.length ?
                        datas.service_categorys[0].name_th : ''),
                    add_warranty_date: moment(datas.delivery_date).format('DD/MM/YYYY') + ' - ' + moment(datas.expired_insurance).format('DD/MM/YYYY'),
                    add_title: (Array.isArray(datas.service_types) && datas.service_types.length ?
                        datas.service_types[0].name_th : ''),
                    add_contact: helpers.getContactChannel(datas.contact_chanel),
                    add_service_status: helpers.getServiceStatus(datas.service_status),
                    val_service_status: datas.service_status,
                    old_service_status: datas.service_status,
                    add_detail: detail,
                    add_sla_val: (Array.isArray(datas.service_types) && datas.service_types.length ?
                        datas.service_types[0].sla : 0),
                    sla_start_date: (datas.sla_start_date ? new Date(datas.sla_start_date) : ''),
                    sla_start_time: (datas.sla_start_date ? moment(datas.sla_start_date).format('H:mm') : ''),
                    sla_end_date: (datas.sla_end_date ? new Date(datas.sla_end_date) : ''),
                    sla_end_time: (datas.sla_end_date ? moment(datas.sla_end_date).format('H:mm') : ''),
                    createby_name: datas.updateby != undefined ? datas.updateby : datas.createby,
                    express: datas.express,
                    value: datas.contenttype,
                    add_sla: datas.sla,
                    multiDataSet: [
                        {
                            columns: [],
                            data: [
                                [
                                    { value: "", },
                                    { value: "", },
                                    { value: "ใบงานเลขที่/ใบตรวจงาน", },
                                    { value: `${datas.service_number}`, },
                                ],
                                [
                                    { value: "บริษัท", },
                                    { value: "", },
                                    { value: "วันที่รับแจ้ง", },
                                    { value: `${moment(datas.created).format('DD/MM/YYYY')}`, },
                                ],
                                [
                                    { value: "ชื่อลูกค้าผู้แจ้ง", },
                                    { value: `${datas.member_first_name + ' ' + datas.member_last_name}`, },
                                    { value: "วันที่ตรวจ", },
                                    { value: `${(datas.sla_start_date ? moment(datas.sla_start_date).format("DD/MM/YYYY") : '')}`, },
                                ],
                                [
                                    { value: "โครงการ", },
                                    { value: `${(Array.isArray(datas.project_homes) && datas.project_homes.length ? datas.project_homes[0].name_th : '')}`, },
                                    { value: "บ้านเลขที่", },
                                    { value: `${datas.home_number}`, },
                                ],
                                [
                                    { value: "โทรศัพท์ติดต่อ", },
                                    { value: `${datas.income_phone}`, },
                                    { value: "", },
                                    { value: `` },
                                ],
                                [
                                    { value: "Email ของลูกค้า", },
                                    { value: "-", },
                                    { value: "", },
                                    { value: "", },
                                ],
                                [
                                    { value: "เจ้าหน้าที่โครงการ", },
                                    { value: "-", },
                                    { value: "โทรศัพท์ติดต่อ", },
                                    { value: "0-2247-3328", },
                                ],
                                [
                                    { value: "บริษัทผู้ดำเนินการ", },
                                    { value: "พร็อพเพอร์ตี้ เพอร์เฟค จํากัด (มหาชน)", },
                                    { value: "โทรศัพท์ติดต่อ", },
                                    { value: "0-2247-3328", },
                                ]
                            ]
                        },
                        {
                            columns: [],
                            data: [
                                [
                                    { value: "สำหรับลูกค้า : ประเมินการทำงาน" }
                                ]
                            ],
                        }, {
                            columns: [
                                { title: "หัวข้อ", width: { wpx: 100 }, style },
                                { title: "A=ดี, B=พอใช้, C=ปรับปรุง", width: { wpx: 150 }, style },
                                { title: "หัวข้อ", width: { wpx: 100 }, style },
                                { title: "A=ดี, B=พอใช้, C=ปรับปรุง", width: { wpx: 150 }, style },
                            ],
                            data: [
                                [
                                    { value: "เจ้าหน้าที่มีความสุภาพ", style },
                                    { value: "", style },
                                    { value: "เวลาในการดำเนินการ", style },
                                    { value: "", style },
                                ],
                                [
                                    { value: "ความเอาใจใส่ดูแล", style },
                                    { value: "", style },
                                    { value: "คุณภาพของงาน", style },
                                    { value: "", style },
                                ],
                                [
                                    { value: "ความพึ่งพอใจโดยรวม", style },
                                    { value: "", style },
                                    { value: "" },
                                    { value: "_____________ ผู้ประเมิน" },
                                ]
                            ]
                        },
                        {
                            columns: [],
                            data: [
                                [
                                    { value: "รายการเข้าดำเนินการ:" },
                                    { value: "วันเริ่มงาน:_____________" },
                                    { value: "วันจบงาน:______________" },
                                    { value: "□งานซ่อม" },
                                    { value: "□งานเก็บประกัน" },

                                ]
                            ],
                        },
                        {
                            columns: [
                                { title: "ลำดับ", width: { wpx: 100 }, style },
                                { title: "รายการ", width: { wpx: 300 }, style },
                                { title: "วันที่เข้าซ่อม", width: { wpx: 150 }, style },
                                { title: "ดำเนินการเรียบร้อย ลูกค้าลงนามรับทราบ", width: { wpx: 200 }, style },
                            ], data: [].concat(FromExcel),
                        },
                        {
                            columns: [],
                            data: [
                                [
                                    { value: "_____________________" },
                                    { value: "□ผ่าน" },
                                    { value: "_____________________" },
                                ],
                                [
                                    { value: "(_____________________)" },
                                    { value: "□ไม่ผ่าน" },
                                    { value: "(_____________________)" },
                                ],
                                [
                                    { value: "วันที่_____________________" },
                                    { value: "" },
                                    { value: "วันที่_____________________" },
                                ],
                                [
                                    { value: "บริษัทที่ขอตรวจ" },
                                    { value: "" },
                                    { value: "เจ้าหน้าที่HOME CARE" },
                                ]
                            ],
                        },
                    ]
                });

                if (datas.service_type_id == "5e2feeced5fbcf576287f461" && datas.service_category_id == "5e232c684d59a834545e911b") {
                    //$(".detail_list").show()
                    this.setState({
                        showDetail10: true
                    })
                } else {
                    //$(".detail_list").hide()
                    this.setState({
                        showDetail10: true
                    })
                }

                fetch(config.url.API_URL + '/coordinate/' + this.state.add_id, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        var FromApi = data.data.map(datas => {
                            //var dcreated = new Date();
                            var detail = <div></div>;

                            if (datas.detail) {
                                detail = datas.detail.split('\n').map((item, i) => {
                                    return <div>{item}<br /></div>;
                                });
                            }

                            return {
                                date: moment(datas.created).format('DD/MM/YYYY H:mm') + ' น.',
                                coordinate: datas.coordinate_name,
                                detail: detail,
                            }
                        });

                        this.setState({
                            coordinate: [].concat(FromApi)
                        });
                    });

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'view'
                });

            });

    }

    closeAdd() {
        this.setState({ addIsOpen: false });
    }

    closeDoneCase() {
        this.setState({ doncaseIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openDoneCase(e) {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/service_complaints/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                var datas = data.data[0];

                this.setState({
                    add_id: datas._id,
                });

                this.setState({ doncaseIsOpen: true });
            });

    }

    submitDoneCase(e) {

        const requestOptions = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                service_status: 'close',
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id,
            }),
        };

        fetch(config.url.API_URL + '/complaints_status/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({ doncaseIsOpen: false });
                this.dataTable();
            });

    }

    openEdit(e) {

        this.clearListDetail();
        this.setState({
            coordinate: [],
            fromList: [],
            value: 'urgent',
            add_sla: 0
        });

        var requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };


        fetch(config.url.API_URL + '/service_complaints/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                var datas = data.data[0];
                if (datas.service_types[0].multi == 1) {
                    this.setState({
                        Ismore: true
                    });
                } else {
                    this.setState({
                        Ismore: false
                    });
                }
                var requestOptions2 = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };
                fetch(config.url.API_URL + '/service_types/?categoryid=' + datas.service_category_id + '&sortnameth=1', requestOptions2)
                    .then(res => res.json())
                    .then(data => {
                        var FromApi = data.data.map(datas => {
                            return { value: datas.id, display: datas.name_th }
                        });
                        this.setState({
                            service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                        });

                        for (var i = 1; i <= datas.detail_list.length; i++) {
                            this.state.fromList.push({
                                row: i
                                , col1: "detail" + i
                                , col2: "subscriber" + i
                                , col3: "operator" + i
                                , col4: "serviceDate" + i
                                , col5: "successDate" + i
                                , col6: "editDate" + i
                                , col7: "note" + i
                                , col8: "serviceStatus" + i
                                , img: "images" + i
                                , images: "img" + i
                                , _id: "_id" + i
                                , service_type_id: "service_type_id" + i
                                , service_type_name: "service_type_name" + i
                            });
                        }
                        if (datas.detail_list != undefined) {
                            datas.detail_list.map((dt, i) => {
                                console.log(dt)
                                this.setState({
                                    ['_id' + (i + 1)]: dt._id,
                                    ['detail' + (i + 1)]: dt.detail,
                                    ['subscriber' + (i + 1)]: dt.subscriber,
                                    ['operator' + (i + 1)]: dt.operator,
                                    ['serviceDate' + (i + 1)]: (dt.serviceDate ? new Date(dt.serviceDate) : null),
                                    ['successDate' + (i + 1)]: (dt.successDate ? new Date(dt.successDate) : null),
                                    ['editDate' + (i + 1)]: (dt.editDate ? new Date(dt.editDate) : null),
                                    ['note' + (i + 1)]: dt.note,
                                    ['serviceStatus' + (i + 1)]: dt.serviceStatus,
                                    ['service_type_id' + (i + 1)]: dt.service_type_id,
                                    ['service_type_name' + (i + 1)]: dt.service_type_name,
                                    ['images' + (i + 1)]: dt.img,
                                    //['img' + (i + 1)]: dt.img.length > 0 ? `${imgpath}${dt.img[0].img}` : "",
                                    ['img' + (i + 1)]: dt.img.length > 0 ? JSON.stringify(dt.img) : "",
                                    img: dt.img.length > 0 ? `${imgpath}${dt.img[0].img}` : "",
                                })
                            });
                        }

                        var create_type = ""
                        if (Array.isArray(datas.user_create) && datas.user_create.length
                            && Array.isArray(datas.user_create[0].user_type) && datas.user_create[0].user_type.length) {
                            create_type = " (" + helpers.getPermission(datas.user_create[0].user_type[0].user_type) + ")";
                        }


                        this.setState({
                            add_id: datas._id,
                            add_number: datas.service_number,
                            add_service_date: moment(datas.created).format('DD/MM/YYYY'),
                            add_service_time: moment(datas.created).format('H:mm'),
                            add_member_name: datas.member_first_name + ' ' + datas.member_last_name,
                            add_owner_name: datas.owner_first_name + ' ' + datas.owner_last_name,
                            add_first_name: datas.member_first_name,
                            add_last_name: datas.member_last_name,
                            add_phone_come: datas.income_phone,
                            add_group: (Array.isArray(datas.service_groups) && datas.service_groups.length ?
                                datas.service_groups[0].name_th : ''),
                            val_group: datas.service_group_id,
                            add_project_name: (Array.isArray(datas.project_homes) && datas.project_homes.length ? datas.project_homes[0].name_th : ''),
                            val_project_name: datas.project_home_id,
                            add_home_number: datas.home_number,
                            add_project_status: helpers.getProjectStatus(datas.project_status),
                            val_project_status: datas.project_status,
                            add_category: (Array.isArray(datas.service_categorys) && datas.service_categorys.length ?
                                datas.service_categorys[0].name_th : ''),
                            val_category: datas.service_category_id,
                            add_warranty_date: moment(datas.delivery_date).format('DD/MM/YYYY') + ' - ' + moment(datas.expired_insurance).format('DD/MM/YYYY'),
                            add_title: (Array.isArray(datas.service_types) && datas.service_types.length ?
                                datas.service_types[0].name_th : ''),
                            val_title: datas.service_type_id,
                            add_contact: helpers.getContactChannel(datas.contact_chanel),
                            add_service_status: helpers.getServiceStatus(datas.service_status),
                            val_service_status: datas.service_status,
                            old_service_status: datas.service_status,
                            add_detail: datas.detail == undefined ? "" : datas.detail,
                            add_sla_val: (Array.isArray(datas.service_types) && datas.service_types.length ?
                                datas.service_types[0].sla : 0),
                            sla_start_date: (datas.sla_start_date != undefined ? new Date(datas.sla_start_date) : ''),
                            sla_start_time: (datas.sla_start_date != undefined ? moment(new Date(datas.sla_start_date)).format('HH:mm') : ''),
                            sla_end_date: (datas.sla_end_date != undefined ? new Date(datas.sla_end_date) : ''),
                            sla_end_time: (datas.sla_end_date != undefined ? moment(new Date(datas.sla_end_date)).format('HH:mm') : ''),
                            createby_name: datas.updateby != undefined ? datas.updateby : datas.createby,
                            express: datas.express,
                            add_sla: datas.sla,
                            value: datas.contenttype
                        });
                    });
                console.log("============this.state.val_title===============" + this.state.val_title)
                console.log("============this.state.val_category===============" + this.state.val_category)

                if (this.state.add_sla) {
                    var Day = parseInt(this.state.add_sla)
                    var DateSLA = new Date(moment(this.state.sla_start_date).add(Day, 'days'));
                    var TimeSLa = this.state.sla_end_time
                    this.setState({
                        sla_end_date: (DateSLA ? new Date(DateSLA) : ''),
                        sla_end_time: TimeSLa,
                        add_sla: Day
                    })
                }
                if (this.state.val_title == "5e2feeced5fbcf576287f461" && this.state.val_category == "5e232c684d59a834545e911b") {
                    //$(".detail_list").show()
                    this.setState({
                        showDetail10: true
                    })
                    console.log("============$(.detail_list).show()===============")
                } else {
                    //$(".detail_list").hide()
                    this.setState({
                        showDetail10: true
                    })
                    console.log("============$(.detail_list).hide()===============")
                }

                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                };

                // fetch(config.url.API_URL + '/service_types/?categoryid=' + this.state.val_category + '&sortnameth=1', requestOptions)
                //     .then(res => res.json())
                //     .then(data => {
                //         // store user details and jwt token in local storage to keep user logged in between page refreshes
                //         //alert(data.status);
                //         var FromApi = data.data.map(datas => {
                //             return { value: datas._id, display: datas.name_th }
                //         });
                //         this.setState({
                //             service_type: [{ value: '', display: 'เลือกเรื่องย่อย' }].concat(FromApi)
                //         });
                //     });

                fetch(config.url.API_URL + '/coordinate/' + this.state.add_id, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        var FromApi = data.data.map(datas => {
                            var detail = <div></div>;

                            if (datas.detail) {
                                detail = datas.detail.split('\n').map((item, i) => {
                                    return <div>{item}<br /></div>;
                                });
                            }
                            return {
                                date: moment(datas.created).format('DD/MM/YYYY H:mm') + ' น.',
                                coordinate: datas.coordinate_name,
                                detail: detail,
                            }
                        });

                        this.setState({
                            coordinate: [].concat(FromApi)
                        });
                    });

                this.setState({
                    addIsOpen: true,
                    methodOpen: 'edit'
                });
            });
    }

    submitEdit(e) {

        this.setState({
            coordinate: []
        });


        var list = [];

        for (var i = 1; i <= 10; i++) {
            if (this.state["detail" + i] != "") {
                list.push({
                    service_type_id: this.state["service_type_id" + i],
                    service_type_name: this.state["service_type_name" + i],
                    detail: this.state["detail" + i],
                    subscriber: this.state["subscriber" + i],
                    operator: this.state["operator" + i],
                    serviceDate: this.state["serviceDate" + i],
                    successDate: this.state["successDate" + i],
                    editDate: this.state["editDate" + i],
                    note: this.state["note" + i],
                    serviceStatus: this.state["serviceStatus" + i],
                    img: this.state["images" + i],
                })
            }
        }

        const requestOptions = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                member_first_name: this.state.add_first_name,
                member_last_name: this.state.add_last_name,
                project_home_id: this.state.val_project_name,
                service_status: this.state.add_service_status,
                service_category_id: this.state.category,
                service_group_id: this.state.val_group,
                service_type_id: this.state.val_title,
                detail: this.state.add_detail,
                service_status: this.state.val_service_status,
                old_service_status: this.state.old_service_status,
                updateby: this.state.create_by,
                updateby_id: this.state.create_by_id,
                income_phone: this.state.add_phone_come,
                contenttype: this.state.value,
                sla: this.state.add_sla,
                sla_start_date: new Date(moment(moment(this.state.sla_start_date).format('YYYY-MM-DD ') + this.state.sla_start_time)),
                sla_end_date: new Date(moment(moment(this.state.sla_end_date).format('YYYY-MM-DD ') + this.state.sla_end_time)),
                detail_list: list,
                sendmail: true,
            }),
        };

        fetch(config.url.API_URL + '/service_complaints/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(data => {
                this.setState({ updateIsOpen: true });
                //this.dataTable();
            });

        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            src_house_no: '',
            src_no: '',
            src_status: '',
            src_category: '',
            src_project: '',
            src_owner: '',
            src_phone: '',
            src_channel: '',
            src_name: '',
            page: 0
        });
        this.setState({ srcIsOpen: true });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    //////////////START dialog Submit/////////////////
    submitCoordinate(e) {
        e.preventDefault();

        //const resultoffice = this.state.department.find( ({ value }) => value === this.state.office_id);
        //console.log("==========resultoffice========="+JSON.stringify(resultoffice))
        const { jwt } = authentication.currentUserValue;
        //console.log(jwt);
        if (this.state.save_value == "save") {
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': jwt,
                },
                body: JSON.stringify({
                    coordinate_name: this.state.create_by,
                    coordinate_id: this.state.create_by_id,
                    //office_email: this.state.office_email,
                    //office_name: (resultoffice===undefined?'':resultoffice.display),
                    //office_id: this.state.office_id,
                    detail: this.state.coor_detail,
                    createname: this.state.create_by,
                    createid: this.state.create_by_id,
                    service_complaint_id: this.state.add_id,
                    title: this.state.title,
                    memeber_name: this.state.member_first_name + ' ' + this.state.member_last_name,
                    member_phone: this.state.member_phone,
                    home_number: this.state.home_number,
                    category_name: this.state.category_name,
                    project_name: this.state.project_name,
                    content: this.state.detail,
                }),
            };

            fetch(config.url.API_URL + '/coordinate', requestOptions)
                .then(res => res.json())
                .then(data => {

                    const requestOptions = {
                        method: 'GET',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': jwt,
                        },
                    };

                    fetch(config.url.API_URL + '/coordinate/' + this.state.add_id, requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            var FromApi = data.data.map(datas => {
                                //var dcreated = new Date();
                                return {
                                    date: moment(datas.created).format('DD/MM/YYYY H:mm') + ' น.',
                                    coordinate: datas.coordinate_name,
                                    detail: datas.detail,
                                }
                            });

                            this.setState({
                                coordinate: [].concat(FromApi)
                            });

                            this.setState({
                                modalIsOpen: false,
                                coor_detail: '',
                                office_id: '5a627dab3fc2394c4f824e94',
                                office_name: '',
                                office_email: '',
                            });
                        });

                });
        } else if (this.state.save_value == "delete") {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': jwt,
                },
                body: JSON.stringify({
                    service_status: 'cancel',
                }),
            };

            fetch(config.url.API_URL + '/service_complaints/' + this.state.add_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': jwt,
                        },
                        body: JSON.stringify({
                            coordinate_name: this.state.create_by,
                            coordinate_id: this.state.create_by_id,
                            //office_email: this.state.office_email,
                            //office_name: (resultoffice===undefined?'':resultoffice.display),
                            //office_id: this.state.office_id,
                            detail: this.state.coor_detail,
                            createname: this.state.create_by,
                            createid: this.state.create_by_id,
                            service_complaint_id: this.state.add_id,
                            title: this.state.title,
                            memeber_name: this.state.member_first_name + ' ' + this.state.member_last_name,
                            member_phone: this.state.member_phone,
                            home_number: this.state.home_number,
                            category_name: this.state.category_name,
                            project_name: this.state.project_name,
                            content: this.state.detail,
                        }),
                    };

                    fetch(config.url.API_URL + '/coordinate', requestOptions)
                        .then(res => res.json())
                        .then(data => {
                            const requestOptions = {
                                method: 'GET',
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': jwt,
                                },
                            };

                            fetch(config.url.API_URL + '/coordinate/' + this.state.add_id, requestOptions)
                                .then(res => res.json())
                                .then(data => {
                                    var FromApi = data.data.map(datas => {
                                        //var dcreated = new Date();
                                        return {
                                            date: moment(datas.created).format('DD/MM/YYYY H:mm') + ' น.',
                                            coordinate: datas.coordinate_name,
                                            detail: datas.detail,
                                        }
                                    });

                                    this.setState({
                                        coordinate: [].concat(FromApi),
                                        modalIsOpen: false,
                                        coor_detail: '',
                                        office_id: '5a627dab3fc2394c4f824e94',
                                        office_name: '',
                                        office_email: '',
                                    });
                                });
                        });
                });
        } else if (this.state.save_value == "coordinated") {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': jwt,
                },
                body: JSON.stringify({
                    service_status: 'coordinated',
                }),
            };

            fetch(config.url.API_URL + '/service_complaints/' + this.state.add_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    ///////add coordinate
                    const requestOptions = {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': jwt,
                        },
                        body: JSON.stringify({
                            coordinate_name: this.state.create_by,
                            coordinate_id: this.state.create_by_id,
                            //office_email: this.state.office_email,
                            //office_name: (resultoffice===undefined?'':resultoffice.display),
                            //office_id: this.state.office_id,
                            detail: this.state.coor_detail,
                            createname: this.state.create_by,
                            createid: this.state.create_by_id,
                            service_complaint_id: this.state.add_id,
                            title: this.state.title,
                            memeber_name: this.state.member_first_name + ' ' + this.state.member_last_name,
                            member_phone: this.state.member_phone,
                            home_number: this.state.home_number,
                            category_name: this.state.category_name,
                            project_name: this.state.project_name,
                            content: this.state.detail,
                        }),
                    };

                    fetch(config.url.API_URL + '/coordinate', requestOptions)
                        .then(res => res.json())
                        .then(data => {

                            const requestOptions = {
                                method: 'GET',
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': jwt,
                                },
                            };

                            fetch(config.url.API_URL + '/coordinate/' + this.state.add_id, requestOptions)
                                .then(res => res.json())
                                .then(data => {
                                    var FromApi = data.data.map(datas => {
                                        //var dcreated = new Date();
                                        return {
                                            date: moment(datas.created).format('DD/MM/YYYY H:mm') + ' น.',
                                            coordinate: datas.coordinate_name,
                                            detail: datas.detail,
                                        }
                                    });

                                    this.setState({
                                        coordinate: [].concat(FromApi)
                                    });
                                });

                            this.setState({
                                modalIsOpen: false,
                                coor_detail: '',
                                office_id: '5a627dab3fc2394c4f824e94',
                                office_name: '',
                                office_email: '',
                            });

                        });
                    ///////add coordinate
                });
        }

        document.getElementById("coordinate-form").reset();
    }

    cancelCoordinate() {
        this.setState({
            coor_detail: ''
            , office_id: '5a627dab3fc2394c4f824e94'
            , office_name: ''
            , office_email: ''
        });
        document.getElementById("coordinate-form").reset();
    }

    openModal(e) {
        e.preventDefault();

        if (this.state.coor_detail.trim() == "") {
            alert("ไม่พบข้อมูลรายละเอียดการประสานงาน กรุณาระบุข้อมูลก่อนบันทึกรายการ");
            return;
        }

        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({
            modalIsOpen: false,
            SLAIsOpen: false
        });
    }

    changeDate_serviceDate1 = date => {
        this.setState({
            serviceDate1: date
        });
    }

    changeDate_serviceDate2 = date => {
        this.setState({
            serviceDate2: date
        });
    }

    changeDate_serviceDate3 = date => {
        this.setState({
            serviceDate3: date
        });
    }

    changeDate_serviceDate4 = date => {
        this.setState({
            serviceDate4: date
        });
    }

    changeDate_serviceDate5 = date => {
        this.setState({
            serviceDate5: date
        });
    }

    changeDate_serviceDate6 = date => {
        this.setState({
            serviceDate6: date
        });
    }

    changeDate_serviceDate7 = date => {
        this.setState({
            serviceDate7: date
        });
    }

    changeDate_serviceDate8 = date => {
        this.setState({
            serviceDate8: date
        });
    }

    changeDate_serviceDate9 = date => {
        this.setState({
            serviceDate9: date
        });
    }

    changeDate_serviceDate10 = date => {
        this.setState({
            serviceDate10: date
        });
    }

    changeDate_successDate1 = date => {
        this.setState({
            successDate1: date
        });
    }

    changeDate_successDate2 = date => {
        this.setState({
            successDate2: date
        });
    }

    changeDate_successDate3 = date => {
        this.setState({
            successDate3: date
        });
    }

    changeDate_successDate4 = date => {
        this.setState({
            successDate4: date
        });
    }

    changeDate_successDate5 = date => {
        this.setState({
            successDate5: date
        });
    }

    changeDate_successDate5 = date => {
        this.setState({
            successDate5: date
        });
    }

    changeDate_successDate6 = date => {
        this.setState({
            successDate6: date
        });
    }

    changeDate_successDate7 = date => {
        this.setState({
            successDate7: date
        });
    }

    changeDate_successDate8 = date => {
        this.setState({
            successDate8: date
        });
    }

    changeDate_successDate9 = date => {
        this.setState({
            successDate9: date
        });
    }

    changeDate_successDate10 = date => {
        this.setState({
            successDate10: date
        });
    }

    changeDate_editDate1 = date => {
        this.setState({
            editDate1: date
        });
    }

    changeDate_editDate2 = date => {
        this.setState({
            editDate2: date
        });
    }

    changeDate_editDate3 = date => {
        this.setState({
            editDate3: date
        });
    }

    changeDate_editDate4 = date => {
        this.setState({
            editDate4: date
        });
    }

    changeDate_editDate5 = date => {
        this.setState({
            editDate5: date
        });
    }

    changeDate_editDate6 = date => {
        this.setState({
            editDate6: date
        });
    }

    changeDate_editDate7 = date => {
        this.setState({
            editDate7: date
        });
    }

    changeDate_editDate8 = date => {
        this.setState({
            editDate8: date
        });
    }

    changeDate_editDate9 = date => {
        this.setState({
            editDate9: date
        });
    }

    changeDate_editDate10 = date => {
        this.setState({
            editDate10: date
        });
    }

    handleContentTypeChange = (event) => {
        this.setState({
            value: event.target.value
        })
    };

    changeDateSLA = (event) => {
        if (event.target.value !== "") {
            var Day = parseInt(event.target.value)
            var DateSLA = new Date(moment(this.state.sla_start_date).add(Day, 'days'));
            var TimeSLa = this.state.sla_end_time
            this.setState({
                sla_end_date: (DateSLA ? new Date(DateSLA) : ''),
                sla_end_time: TimeSLa,
                add_sla: Day
            })
        } else {
            this.setState({
                add_sla: 0
            })
        }
    }

    openSLA = (e) => {
        if (this.state.add_sla && e.currentTarget.attributes.length >= 4) {
            var detail_id = e.currentTarget.attributes["data-id"].value
            var value = new Date(e.currentTarget.attributes["value"].value)
            var sla_day = parseInt(this.state.add_sla)
            var DateSLANormal = new Date(moment(value).addWorkingTime(sla_day, 'days'));
            this.setState({
                SLAIsOpen: true,
                sla_detail_start_date: new Date(value),
                sla_detail_end_date: new Date(DateSLANormal),
                detail_id: detail_id
            });
        } else {
            alert("กรุณาใส่จำนวนวัน และวันที่ช่างเข้า")
        }

    }

    submitSLANormal = () => {

        const requestOptions = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                detail_id: this.state.detail_id,
                sla_start_date: new Date(moment(moment(this.state.sla_detail_start_date).format('YYYY-MM-DD HH:mm:ss'))),
                sla_end_date: new Date(moment(moment(this.state.sla_detail_end_date).format('YYYY-MM-DD HH:mm:ss'))),
            }),
        };

        fetch(config.url.API_URL + '/service_complaints_sla/' + this.state.add_id, requestOptions)
            .then(res => res.json())
            .then(data => {
                //this.dataTable();
            });

        this.setState({ SLAIsOpen: false });
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
                padding: 8,
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Home Care Worksheet List</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">worksheet</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                </div>
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table className={StyledTableCell} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: "10px" }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: "130px" }}>วันที่รับเรื่อง</StyledTableCell>
                                                    <StyledTableCell style={{ width: "auto" }}>ผู้แจ้ง</StyledTableCell>
                                                    <StyledTableCell style={{ width: "90px" }}>เบอร์โทรเข้า</StyledTableCell>
                                                    <StyledTableCell style={{ width: "auto" }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: "auto" }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: "90px" }}>สถานะประกัน</StyledTableCell>
                                                    <StyledTableCell style={{ width: "auto" }}>เรื่อง</StyledTableCell>
                                                    <StyledTableCell style={{ width: "250px" }}>ระยะประกัน</StyledTableCell>
                                                    <StyledTableCell style={{ width: "auto" }}>สถานะในงาน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: "100px" }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={i}>
                                                                    <StyledTableCell className="text-center"><span className={(data.express && "text-express" || "text-default")}>{data.number}</span></StyledTableCell>
                                                                    <StyledTableCell>{data.service_date} {data.service_time}</StyledTableCell>
                                                                    <StyledTableCell>{data.member_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone_come}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.home_number}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_status}</StyledTableCell>
                                                                    <StyledTableCell>{data.category}</StyledTableCell>
                                                                    <StyledTableCell>{data.warranty_date}</StyledTableCell>
                                                                    <StyledTableCell>{data.service_status}</StyledTableCell>
                                                                    {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                    {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                    <StyledTableCell style={{ textAlign: 'center' }}>
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" />View</button>
                                                                        {(this.state.user_permission[37].permission == 1 &&
                                                                            <div>{data.btnUpdate}</div>
                                                                        )}
                                                                        {(this.state.user_permission[38].permission == 1 &&
                                                                            <div>{data.btnDoneCase}</div>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{this.state.methodOpen == 'add' && "เพิ่มข้อมูล" || this.state.methodOpen == 'edit' && "แก้ไขข้อมูล" || this.state.methodOpen == 'view' && "ตรวจสอบข้อมูล"}</ModalTitle>
                        <ExcelFile filename={(`ใบตรวจ Home Care-${this.state.add_number}-` + moment().format('DDMMYYYY')
                        )} element={(this.state.user_permission[60].permission == 1 &&
                            <button className="btn-advance" style={{ height: 45, width: 45, float: "none" }}><img src={"../dist/img/icon/ic_report_01.png"} className="menu-icon" /></button>
                        )}>
                            <ExcelSheet dataSet={this.state.multiDataSet} name="Organization" />
                        </ExcelFile>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">เลขที่ :</div>
                                <div className="col-sm-4">
                                    <div className="form-control">{this.state.add_number} {(this.state.express && "(เร่งด่วน)")}</div>
                                </div>
                                <div className="col-sm-2 text-right">วันที่รับเรื่อง :</div>
                                <div className="col-sm-3">
                                    <div className="form-control" >{this.state.add_service_date}</div>
                                </div>
                            </div>

                            <div className="row mb-3">

                                <div className="col-sm-2 text-right">เจ้าบ้าน :</div>
                                <div className="col-sm-4">
                                    <div className="form-control">{this.state.add_owner_name}</div>
                                </div>

                                <div className="col-sm-2 text-right">เบอร์โทรเข้า :</div>
                                <div className="col-sm-3">
                                    {
                                        this.state.methodOpen == 'edit' &&
                                        (<input type="text" className="form-control" id="add_phone_come" name="add_phone_come" defaultValue={this.state.add_phone_come} onChange={this.change} />)
                                        || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.add_phone_come}</div>)
                                    }
                                </div>
                            </div>

                            <div className="row mb-3">

                                <div className="col-sm-2 text-right">ผู้แจ้ง :</div>
                                <div className="col-sm-4">
                                    {
                                        this.state.methodOpen == 'edit' &&
                                        (<div className="row">
                                            <input type="text" className="form-control col-sm-5" id="add_first_name" name="add_first_name" style={{ marginLeft: "8px" }} defaultValue={this.state.add_first_name} onChange={this.change} />
                                            <input type="text" className="form-control col-sm-5" id="add_last_name" name="add_last_name" style={{ marginLeft: "8px" }} defaultValue={this.state.add_last_name} onChange={this.change} /></div>)
                                        || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.add_member_name}</div>)
                                    }
                                </div>

                                <div className="col-sm-2 text-right">ระยะเวลาประกัน :</div>
                                <div className="col-sm-3" >
                                    <div className="form-control" >{this.state.add_warranty_date}</div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">บ้านเลขที่ :</div>
                                <div className="col-sm-4">
                                    {
                                        this.state.methodOpen == 'edit' &&
                                        (<input type="text" className="form-control" id="add_home_number" name="add_home_number" defaultValue={this.state.add_home_number} onChange={this.change} />)
                                        || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.add_home_number}</div>)
                                    }
                                </div>
                                <div className="col-sm-2 text-right">สถานะ :</div>
                                <div className="col-sm-3">
                                    <div className="form-control" >{this.state.add_project_status}</div>
                                    {
                                        /*
                                            <select className="form-control" name="add_project_status" onChange={this.change}>
                                                <option value="">เลือกสถานะ</option>
                                                <option value="book" selected={(this.state.val_project_status=='book' && 'selected')}>จอง</option>
                                                <option value="sign" selected={(this.state.val_project_status=='sign' && 'selected')}>ทำสัญญา</option>
                                                <option value="transfer" selected={(this.state.val_project_status=='transfer' && 'selected')}>โอน(ยังไม่รับมอบบ้าน)</option>
                                                <option value="insurance" selected={(this.state.val_project_status=='insurance' && 'selected')}>ในประกัน(คิดจากเวลาประกัน)</option>
                                                <option value="expire" selected={(this.state.val_project_status=='expire' && 'selected')}>หมดประกัน(คิดจากเวลาประกัน)</option>
                                            </select>
                                        */
                                    }
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">โครงการ :</div>
                                <div className="col-sm-4">
                                    {
                                        this.state.methodOpen == 'edit' &&
                                        (<select className="form-control" id="val_project_name" name="val_project_name" style={{ height: 45 }} onChange={this.change}>
                                            {
                                                this.state.project_home.map((datas) =>
                                                    <option value={datas.value} selected={this.state.val_project_name == datas.value && "selected"}>{datas.display}</option>)
                                            }
                                        </select>)
                                        || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.add_project_name}</div>)
                                    }
                                </div>

                                <div className="col-sm-2 text-right">ช่องทางการแจ้ง :</div>
                                <div className="col-sm-3">
                                    <div className="form-control">{this.state.add_contact}</div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">หมวดเรื่อง :</div>
                                <div className="col-sm-4">
                                    {/*
                                    this.state.methodOpen == 'edit' && 
                                <select className="form-control" name="val_category" onChange={this.change}>
                                    {this.state.service_category.map((datas) => 
                                    <option value={datas.value} selected={(this.state.val_category==datas.value && 'selected')}>{datas.display}</option>)
                                    }
                                </select>
                                ||
                                <div className="form-control" >{this.state.add_category}</div>
                                */}
                                    <div className="form-control" >{this.state.add_category}</div>
                                </div>

                                <div className="col-sm-2 text-right">ผู้รับเรื่อง :</div>
                                <div className="col-sm-3">
                                    <div className="form-control" style={{ height: "auto", minHeight: "38px" }}>{this.state.createby_name}</div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">กลุ่มหัวข้อ :</div>
                                <div className="col-sm-4">
                                    {/*
                                    this.state.methodOpen == 'edit' && 
                                <select className="form-control" name="val_category" onChange={this.change}>
                                    {this.state.service_category.map((datas) => 
                                    <option value={datas.value} selected={(this.state.val_category==datas.value && 'selected')}>{datas.display}</option>)
                                    }
                                </select>
                                ||
                                <div className="form-control" >{this.state.add_category}</div>
                                */}
                                    <div className="form-control" >{this.state.add_group}</div>
                                </div>

                                <div className="col-sm-2 text-right">สถานะในงาน :</div>
                                <div className="col-sm-3">
                                    {
                                        this.state.methodOpen == 'edit' &&
                                        (<select className="form-control" id="val_service_status" name="val_service_status" onChange={this.change}>
                                            <option value="0">เลือกสถานะในงาน</option>
                                            <option value="progress" selected={this.state.val_service_status == "progress" && "selected"}>Call Center รับเรื่อง</option>
                                            <option value="doing" selected={this.state.val_service_status == "doing" && "selected"}>กำลังดำเนินการ</option>
                                            {/* <option value="coordinated" className="text-danger" selected={this.state.val_service_status == "coordinated" && "selected"}>ประสานงานแล้ว</option> */}
                                            <option value="cancel" selected={this.state.val_service_status == "cancel" && "selected"}>ยกเลิก</option>
                                            <option value="close" className="text-success" selected={this.state.val_service_status == "close" && "selected"}>จบงาน</option>
                                        </select>) ||
                                        this.state.methodOpen == 'view' && (<div className="form-control">{this.state.add_service_status}</div>)
                                    }
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">เรื่องย่อย :</div>
                                <div className="col-sm-4">
                                    {/*
                                        this.state.methodOpen == 'edit' && 
                                    <select className="form-control" name="val_title" onChange={this.change}>
                                        {this.state.service_type.map((datas) => 
                                        <option value={datas.value} selected={(this.state.val_title==datas.value && 'selected')}>{datas.display}</option>)}
                                    </select>
                                    ||
                                    <div className="form-control" style={{height: "auto", minHeight: "38px"}}>{this.state.add_title}</div>
                                */}
                                    <div className="form-control" style={{ height: "auto", minHeight: "38px" }}>{this.state.add_title}</div>
                                </div>

                                {/* <div className="col-sm-2 text-right">ช่องทางการแจ้ง :</div>
                                <div className="col-sm-3">
                                    <div className="form-control">{this.state.add_contact}</div>
                                </div> */}
                                {/* <div className="col-sm-2 text-right">SLA :</div>
                                <div className="col-sm-3">
                                    <div className="form-control">{(this.state.add_sla_val ? (this.state.add_sla_val > 24 ? (this.state.add_sla_val / 24) + ' วัน' : this.state.add_sla_val + ' ชั่วโมง') : '-')}</div>
                                </div> */}

                                <div className="col-sm-2 text-right" style={{ fontFamily: "db_heaventmed_cond", fontSize: "18px" }}>SLA :</div>
                                {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                    (<div><RadioGroup aria-label="contenttype" name="contenttype" value={this.state.value} onChange={this.handleContentTypeChange} style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div><FormControlLabel value="urgent" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "18px" }}>Urgent</span>} /></div>
                                        <div><FormControlLabel value="normal" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "18px" }}>Normal</span>} /></div>
                                    </RadioGroup></div>)
                                    : (<div><RadioGroup aria-label="contenttype" name="contenttype" value={this.state.value} onChange={this.handleContentTypeChange} style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div><FormControlLabel value="urgent" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "18px" }}>Urgent</span>} disabled /></div>
                                        <div><FormControlLabel value="normal" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "18px" }}>Normal</span>} disabled /></div>
                                    </RadioGroup></div>)}

                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">รายละเอียด :</div>
                                <div className="col-sm-4">
                                    {
                                        this.state.methodOpen == 'edit' &&
                                        (<textarea className="form-control" rows={2} defaultValue={this.state.add_detail} name="add_detail" onChange={this.change} />)
                                        || this.state.methodOpen == 'view' && (<div className="form-control" style={{ height: "auto", minHeight: '38px' }}>{this.state.add_detail}</div>)
                                    }
                                </div>

                                <div className="col-sm-2 text-right">SLA(วัน) :</div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_sla" name="add_sla" value={this.state.add_sla} onChange={this.changeDateSLA} />)
                                        : (<div className="form-control">{this.state.add_sla}</div>)}
                                </div>

                            </div>
                            {
                                this.state.value == 'urgent' ? <div className="row mb-3">
                                    <div className="col-sm-2 text-right">SLA เริ่มต้น :</div>
                                    <div className="col-sm-2">
                                        {
                                            this.state.methodOpen == 'edit' &&
                                            (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" onChange={this.changeSLAStartDate} selected={this.state.sla_start_date} className="form-control" dateFormat="dd/MM/yyyy" />)
                                            || this.state.methodOpen == 'view' && (<div className="form-control">{moment(this.state.sla_start_date).format('DD/MM/YYYY')}</div>)
                                        }
                                    </div>
                                    <div className="col-sm-2">
                                        {
                                            this.state.methodOpen == 'edit' &&
                                            (<input type="time" className="form-control" onChange={this.change} defaultValue={this.state.sla_start_time} />)
                                            || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.sla_start_time}</div>)
                                        }
                                    </div>



                                </div> : <div className="row mb-3">
                                    <div className="col-sm-2 text-right"></div>
                                    <div className="col-sm-4">
                                    </div>

                                </div>
                            }

                            {
                                this.state.value == 'urgent' ? <div className="row mb-3">
                                    <div className="col-sm-2 text-right">SLA สิ้นสุด :</div>
                                    <div className="col-sm-2">
                                        {
                                            this.state.methodOpen == 'edit' &&
                                            (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.sla_end_date} onChange={this.changeSLAEndDate} id="sla_end_date" name="sla_end_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                            || this.state.methodOpen == 'view' && (<div className="form-control">{moment(this.state.sla_end_date).format('DD/MM/YYYY')}</div>)
                                        }
                                    </div>
                                    <div className="col-sm-2">
                                        {
                                            this.state.methodOpen == 'edit' &&
                                            (<input type="time" className="form-control" name="sla_end_time" onChange={this.change} defaultValue={this.state.sla_end_time} />)
                                            || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.sla_end_time}</div>)
                                        }
                                    </div>

                                    {/* <div className="col-sm-2 text-right">SLA(วัน) :</div>
                                    <div className="col-sm-3">
                                        {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                            (<input type="text" className="form-control" id="add_sla" name="add_sla" defaultValue={this.state.add_sla} onChange={this.changeDateSLA} />)
                                            : (<div className="form-control">{this.state.add_sla}</div>)}
                                    </div> */}

                                </div> : <div className="row mb-3">
                                    <div className="col-sm-2 text-right"></div>
                                    <div className="col-sm-4">
                                    </div>
                                    {/* <div className="col-sm-2 text-right">SLA(วัน) :</div>
                                        <div className="col-sm-3">
                                            {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                                (<input type="text" className="form-control" id="add_sla" name="add_sla" defaultValue={this.state.add_sla} onChange={this.changeDateSLA} />)
                                                : (<div className="form-control">{this.state.add_sla}</div>)}
                                        </div> */}

                                </div>
                            }

                            {/* {(this.state.add_sla_val ?
                                (<div><div className="row mb-3">
                                    <div className="col-sm-2 text-right">SLA เริ่มต้น :</div>
                                    <div className="col-sm-2">
                                        {
                                            this.state.methodOpen == 'edit' &&
                                            (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" readOnly onChange={this.changeSLAStartDate} selected={this.state.sla_start_date} className="form-control" dateFormat="dd/MM/yyyy" />)
                                            || this.state.methodOpen == 'view' && (<div className="form-control">{moment(this.state.sla_start_date).format('DD/MM/YYYY')}</div>)
                                        }
                                    </div>
                                    <div className="col-sm-2">
                                        {
                                            this.state.methodOpen == 'edit' &&
                                            (<input type="time" className="form-control" readOnly defaultValue={this.state.sla_start_time} />)
                                            || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.sla_start_time}</div>)
                                        }
                                    </div>
                                </div>

                                    <div className="row mb-3">
                                        <div className="col-sm-2 text-right">SLA สิ้นสุด :</div>
                                        <div className="col-sm-2">
                                            {
                                                this.state.methodOpen == 'edit' &&
                                                (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.sla_end_date} onChange={this.changeSLAEndDate} id="sla_end_date" name="sla_end_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                                || this.state.methodOpen == 'view' && (<div className="form-control">{moment(this.state.sla_end_date).format('DD/MM/YYYY')}</div>)
                                            }
                                        </div>
                                        <div className="col-sm-2">
                                            {
                                                this.state.methodOpen == 'edit' &&
                                                (<input type="time" className="form-control" name="sla_end_time" onChange={this.change} defaultValue={this.state.sla_end_time} />)
                                                || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.sla_end_time}</div>)
                                            }
                                        </div>
                                    </div>
                                </div>) : (<div></div>))} */}
                            {(this.state.showDetail10 &&
                                (<div className="row mb-3 mt-5 detail_list">
                                    <div className="col-sm-12">
                                        <table id="table-coodinate" className="table" style={{ width: "100%" }}>
                                            <thead className="table-base">
                                                <tr>
                                                    <th width="5%" className="text-center">No</th>
                                                    {this.state.value == 'normal' && <th className="text-center">SLA</th>}
                                                    {this.state.Ismore ? <th width="13%" className="text-center">รายการย่อย</th> : ""}
                                                    <th width="20%" className="text-center">รายการซ่อม</th>
                                                    <th width="12%" className="text-center">ผู้เซ็นต์รับ</th>
                                                    <th width="12%" className="text-center">ผู้ดำเนินการ</th>
                                                    <th width="10%" className="text-center">วันที่ช่างเข้า</th>
                                                    <th width="10%" className="text-center">วันที่แล้วเสร็จ</th>
                                                    <th width="10%" style={{ fontSize: "16px" }} className="text-center">วันที่แก้ไขเพิ่มเติม</th>
                                                    <th className="text-center">หมายเหตุ</th>
                                                    {
                                                        this.state.img != '' ? <th className="text-center">Image</th> : <th></th>
                                                    }
                                                    <th width="13%" className="text-center">สถานะการซ่อม</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    //สถานะการซ่อม coordinate:ประสานงานแล้ว, progress:กำลังดำเนินการ, finish:จบงาน, cancel:ยกเลิก
                                                    (this.state.methodOpen == 'view' &&
                                                        this.state.fromList.map((data, i) => (
                                                            <tr key={i}>
                                                                <td>{data.row}</td>
                                                                {this.state.value == 'normal' && <td><button type="button" className="btn btn-light" value={this.state[data.col4]} data-id={this.state[data._id]} onClick={this.openSLA}><img src="dist/img/icon/ic_about_us.png" className="btn-icon" /></button></td>}

                                                                {this.state.Ismore ? <td>
                                                                    <TextareaAutosize className="form-control" name={data.service_type_name} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.service_type_name]} onChange={this.change} disabled />
                                                                    {/* <input type="text" className="form-control" name={data.service_type_name}
                                                                        onChange={this.change} defaultValue={this.state[data.service_type_name]} disabled /> */}
                                                                </td> : ""}
                                                                <td>
                                                                    <TextareaAutosize className="form-control" name={data.col1} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.col1]} onChange={this.change} disabled />
                                                                    {/* <input type="text" className="form-control" name={data.col1}
                                                                        onChange={this.change} defaultValue={this.state[data.col1]} disabled /> */}
                                                                </td>
                                                                <td>
                                                                    <TextareaAutosize className="form-control" name={data.col2} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.col2]} onChange={this.change} disabled />
                                                                    {/* <input type="text" className="form-control" name={data.col2}
                                                                        defaultValue={this.state[data.col2]} onChange={this.change} disabled /> */}
                                                                </td>
                                                                <td>
                                                                    <TextareaAutosize className="form-control" name={data.col3} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.col3]} onChange={this.change} disabled />
                                                                    {/* <input type="text" className="form-control" name={data.col3}
                                                                        defaultValue={this.state[data.col3]} onChange={this.change} disabled /> */}
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-control" selected={this.state[data.col4]}
                                                                        name={data.col4} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col4]} disabled />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-control" selected={this.state[data.col5]}
                                                                        name={data.col5} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col5]} disabled />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-control" selected={this.state[data.col6]}
                                                                        name={data.col6} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col6]} disabled />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-control" name={data.col7}
                                                                        defaultValue={this.state[data.col7]} onChange={this.change} disabled />
                                                                </td>
                                                                {/* {
                                                                <td>{this.state[data.images] != '' ? <button type="button" className="btn btn-light" value={this.state[data.images]} data-id={this.state[data.images]} onClick={this.openImg}><i className="far fa-image"></i></button> : ""}</td>
                                                            } */}
                                                                {this.state[data.images] != '' ? <td><button type="button" className="btn btn-light" value={this.state[data.images]} data-id={this.state[data.images]} onClick={this.openImg}><i className="far fa-image"></i></button></td> : <td></td>}

                                                                <td><TextareaAutosize className="form-control" name={data.col8} aria-label="minimum height" rowsMin={1} defaultValue={(this.state[data.col8] == "coordinate" && "Call Center รับเรื่อง" ||
                                                                    this.state[data.col8] == "progress" && "กำลังดำเนินการ" ||
                                                                    this.state[data.col8] == "finish" && "จบงาน" ||
                                                                    this.state[data.col8] == "cancel" && "ยกเลิก" ||
                                                                    this.state[data.col8] == "" && "")} disabled /></td>
                                                                {/* <td>{(this.state[data.col8] == "coordinate" && "Call Center รับเรื่อง" ||
                                                                    this.state[data.col8] == "progress" && "กำลังดำเนินการ" ||
                                                                    this.state[data.col8] == "finish" && "จบงาน" ||
                                                                    this.state[data.col8] == "cancel" && "ยกเลิก")}
                                                                </td> */}
                                                            </tr>
                                                        )) ||
                                                        this.state.methodOpen == 'edit' &&
                                                        this.state.fromList.map((data, i) => (
                                                            <tr key={i}>
                                                                <td>{data.row}</td>
                                                                {this.state.value == 'normal' && <td><button type="button" className="btn btn-light" value={this.state[data.col4]} data-id={this.state[data._id]} onClick={this.openSLA}><img src="dist/img/icon/ic_about_us.png" className="btn-icon" /></button></td>}


                                                                {this.state.Ismore ? <td>
                                                                    <select className="form-custom" name={data.service_type_id} onChange={this.change} disabled>
                                                                        {this.state.service_type.map((datas) => this.showOption(this.state[data.service_type_id], datas.value, datas.display))}
                                                                    </select>
                                                                    {/* <input type="text" className="form-control" name={data.service_type_name}
                                                                        onChange={this.change} defaultValue={this.state[data.service_type_name]} disabled /> */}
                                                                </td> : ""}
                                                                <td>
                                                                    <TextareaAutosize className="form-control" name={data.col1} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.col1]} onChange={this.change} />
                                                                    {/* <input type="text" className="form-control" name={data.col1}
                                                                        onChange={this.change} defaultValue={this.state[data.col1]} disabled /> */}
                                                                </td>
                                                                <td>
                                                                    <TextareaAutosize className="form-control" name={data.col2} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.col2]} onChange={this.change} />
                                                                    {/* <input type="text" className="form-control" name={data.col2}
                                                                        defaultValue={this.state[data.col2]} onChange={this.change} disabled /> */}
                                                                </td>
                                                                <td>
                                                                    <TextareaAutosize className="form-control" name={data.col3} aria-label="minimum height" rowsMin={1} defaultValue={this.state[data.col3]} onChange={this.change} />
                                                                    {/* <input type="text" className="form-control" name={data.col3}
                                                                        defaultValue={this.state[data.col3]} onChange={this.change} disabled /> */}
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-control" selected={this.state[data.col4]}
                                                                        name={data.col4} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col4]} />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-control" selected={this.state[data.col5]}
                                                                        name={data.col5} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col5]} />
                                                                </td>
                                                                <td>
                                                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" className="form-control" selected={this.state[data.col6]}
                                                                        name={data.col6} dateFormat="dd/MM/yyyy" onChange={this['changeDate_' + data.col6]} />
                                                                </td>
                                                                <td>
                                                                    <input type="text" className="form-control" name={data.col7}
                                                                        defaultValue={this.state[data.col7]} onChange={this.change} />
                                                                </td>
                                                                {/* {
                                                                    <td>{this.state[data.images] != '' ? <button type="button" className="btn btn-light" value={this.state[data.images]} data-id={this.state[data.images]} onClick={this.openImg}><i className="far fa-image"></i></button> : ""}</td>
                                                                } */}
                                                                {this.state[data.images] != '' ? <td><button type="button" className="btn btn-light" value={this.state[data.images]} data-id={this.state[data.images]} onClick={this.openImg}><i className="far fa-image"></i></button></td> : <td></td>}
                                                                <td>
                                                                    <select className="form-control" name={data.col8} onChange={this.change}>
                                                                        <option value="">เลือกสถานะการซ่อม</option>
                                                                        <option selected={this.state[data.col8] == "coordinate" && "selected"} value="coordinate">Call Center รับเรื่อง</option>
                                                                        <option selected={this.state[data.col8] == "progress" && "selected"} value="progress">กำลังดำเนินการ</option>
                                                                        <option selected={this.state[data.col8] == "finish" && "selected"} value="finish">จบงาน</option>
                                                                        <option selected={this.state[data.col8] == "cancel" && "selected"} value="cancel">ยกเลิก</option>
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>)
                            )}

                            <div className="row mb-3 mt-5">
                                <div className="col-sm-12">
                                    <table id="table-coodinate" className="table">
                                        <thead className="table-base">
                                            <tr>
                                                <th width="20%">วันที่ประสานงาน</th>
                                                <th width="20%">ผู้ประสานงาน</th>
                                                <th>รายละเอียดการประสานงาน</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.coordinate.map((data) => (
                                                <tr>
                                                    <td>{data.date}</td>
                                                    <td>{data.coordinate}</td>
                                                    <td>{data.detail}</td>
                                                </tr>
                                            ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </form>
                        {this.state.methodOpen == 'edit' &&
                            <form id="coordinate-form">
                                <div className="row mt-3">
                                    <div className="col-sm-1" />
                                    <div className="col-sm-3 text-right"><span className="label">หมายเหตุ</span></div>
                                    <div className="col-sm-5">
                                        <textarea className="col-sm-12 form-control" rows={3} defaultValue={""} onChange={this.change} name="coor_detail" />
                                    </div>
                                </div>
                                {/* <div className="row mt-3">
                                    <div className="col-sm-1" />
                                    <div className="col-sm-3 text-right"><span className="label">การบันทึก</span></div>
                                    <div className="col-sm-5">
                                        <select className="form-control" style={{ height: 45 }} onChange={this.change} name="save_value">
                                            <option value="save" >บันทึกการประสานงาน</option>
                                            <option value="delete" >ยกเลิก</option>
                                            <option value="coordinated" >ประสานงานแล้ว</option>
                                        </select>
                                    </div>
                                </div> */}
                                <div className="row mt-5 mb-3">
                                    <div className="col-sm-12 text-center">
                                        <input type="button" className="btn btn-success" name="Save" onClick={this.openModal} defaultValue="บันทึก" />
                                        <input type="button" className="btn btn-default ml-3" name="Cancel" onClick={this.cancelCoordinate} defaultValue="เคลียร์" />
                                    </div>
                                </div>
                            </form>
                        }
                    </ModalBody>
                    <ModalFooter>
                        {
                            this.state.methodOpen == 'edit' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>)
                            || this.state.methodOpen == 'view' &&
                            (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>)
                        }
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.doncaseIsOpen} onHide={this.closeDoneCase}>
                    <ModalHeader>
                        <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <h4>รายการนี้ประสานงานเรียบร้อยแล้ว ยืนยัน จบงาน ใช่หรือไม่</h4>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDoneCase}>ยกเลิก</button>
                        <button className="btn btn-success" data-id={this.state.add_id} onClick={this.submitDoneCase}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เลขที่ใบงาน :</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_no" name="src_no" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะใบงาน :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" id="src_status" name="src_status" onChange={this.change}>
                                        <option value="0">เลือกสถานะในงาน</option>
                                        <option value="progress" >Call Center รับเรื่อง</option>
                                        <option value="doing" >กำลังดำเนินการ</option>
                                        {/* <option value="coordinated" className="text-danger">ประสานงานแล้ว</option> */}
                                        <option value="cancel">ยกเลิก</option>
                                        <option value="close" className="text-success">จบงาน</option>
                                    </select>

                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">บ้านเลขที่ :</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_house_no" name="src_house_no" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ :</div>
                                <div className="col-sm-4">
                                    <select className="form-control" id="src_project" name="src_project" style={{ height: 45 }} onChange={this.change}>
                                        {this.state.project_home.map((datas, i) => <option key={i} value={datas.value}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ผู้แจ้ง :</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name" name="src_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หมวดเรื่อง :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="src_category" onChange={this.change}>
                                        {this.state.service_category.map((datas, i) =>
                                            <option key={i} value={datas.value} >{datas.display}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทรติดต่อ :</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_phone" name="src_phone" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ช่องทางการแจ้ง :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" id="src_channel" name="src_channel" onChange={this.change}>
                                        <option value="">เลือกช่องทางการแจ้ง</option>
                                        <option value="cc" >Call Center</option>
                                        <option value="mobile" >Mobile Application</option>
                                    </select>
                                </div>
                            </div>
                        </form>

                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.modalIsOpen} onHide={this.closeModal}>
                    <ModalHeader>
                        <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <h3>คุณต้องการบันทึกรายการนี้ใช่หรือไม่</h3>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeModal}>ยกเลิก</button>
                        <button className="btn btn-info" onClick={this.submitCoordinate}>บันทึก</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.SLAIsOpen} onHide={this.closeModal}>
                    <ModalHeader>
                        <ModalTitle>SLA</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row mb-3">
                            <div className="col-sm-2 text-right">SLA เริ่มต้น :</div>
                            <div className="col-sm-4">
                                {
                                    this.state.methodOpen == 'edit' &&
                                    (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" readOnly onChange={this.changeSLAStartDate} selected={this.state.sla_detail_start_date} className="form-control" dateFormat="dd/MM/yyyy" />)
                                    || this.state.methodOpen == 'view' && (<div className="form-control">{moment(this.state.sla_detail_start_date).format('DD/MM/YYYY')}</div>)
                                }
                            </div>
                            <div className="col-sm-4">
                                {
                                    this.state.methodOpen == 'edit' &&
                                    (<input type="time" className="form-control" defaultValue={this.state.sla_start_time} />)
                                    || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.sla_start_time}</div>)
                                }
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-sm-2 text-right">SLA สิ้นสุด :</div>
                            <div className="col-sm-4">
                                {
                                    this.state.methodOpen == 'edit' &&
                                    (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.sla_detail_end_date} onChange={this.changeSLAEndDate} id="sla_end_date" name="sla_end_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                    || this.state.methodOpen == 'view' && (<div className="form-control">{moment(this.state.sla_detail_end_date).format('DD/MM/YYYY')}</div>)
                                }
                            </div>
                            <div className="col-sm-4">
                                {
                                    this.state.methodOpen == 'edit' &&
                                    (<input type="time" className="form-control" name="sla_end_time" onChange={this.change} defaultValue={this.state.sla_detail_end_time} />)
                                    || this.state.methodOpen == 'view' && (<div className="form-control">{this.state.sla_detail_end_time}</div>)
                                }
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeModal}>ยกเลิก</button>
                        {this.state.methodOpen == 'edit' && <button className="btn btn-info" onClick={this.submitSLANormal}>บันทึก</button>}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.ImgIsOpen} onHide={this.closeImg} size="lg">
                    <ModalHeader>
                        <ModalTitle></ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12 center">
                                    {(this.state.imagephoto || []).map((url, i) => (
                                        <img key={i} src={url} alt={i} height="200" width="auto" />
                                    ))}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeImg}>ปิด</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
export default withRouter(Worksheet);
